export enum PublicSurface {
  CREATE = 'create',
  PUBLISH = 'publish',
  INSIGHTS = 'insights',
  COMMUNITY = 'community',
}

export enum PublicSurfaceState {
  EMPTY_STATE = 'emptyState',
  SAMPLE_DATA = 'sampleData',
  TEMPLATES = 'templates',
  COMPOSER = 'composer',
  DRAFT_LIST = 'draftList',
}

export enum PublicEntryType {
  MARKETING_REDIRECT = 'marketingRedirect',
  EMBEDDED_DEMO = 'embeddedDemo',
  DIRECT = 'direct',
  OTHER = 'other',
}

export enum PublicDraftCreationSource {
  BLANK = 'blank',
  TEMPLATE = 'template',
  SHARE_NOW_RETURN = 'shareNowReturn',
}

export enum PublicShareMethod {
  COPY_TEXT = 'copyText',
  DOWNLOAD_MEDIA = 'downloadMedia',
  OPEN_NETWORK = 'openNetwork',
}

export { PublicSignupTrigger } from '@buffer-mono/shared-utils/publicTierAttribution'

export enum PublicHandoffSource {
  PUBLIC_TIER = 'publicTier',
  COMPOSER_WRAPPER = 'composerWrapper',
}

export enum PublicImageUploadAction {
  ADD = 'add',
  REPLACE = 'replace',
}
